
import React, { useContext } from 'react';

import { ResearchContext } from '../../ResearchContext';


import {
    Autocomplete,
    Grid,
    TextField
} from '@mui/material';
import { SearchType } from "../../../../../helpers";


export function TipoUfficioFilter() {

    const {

        state,

        isLoadingTipiUfficiRicerca,

        tipoUfficioFilter,
        setTipoUfficioFilter,

        isLoadingFilterFromCookies,
        setIsLoadingFilterFromCookies,

        activeSearchType,

    } = useContext(ResearchContext);

    const {
        tipiUfficiRicercaOptions,
    } = state;

    return activeSearchType == SearchType.TipoUfficio &&
        <Grid container>
            <Grid item xs={12} padding={1} >
                <Autocomplete
                    disabled={isLoadingTipiUfficiRicerca}
                    fullWidth
                    options={tipiUfficiRicercaOptions}
                    onChange={(e, value) => {
                        if (isLoadingFilterFromCookies) {
                            setIsLoadingFilterFromCookies(false);
                        }

                        setTipoUfficioFilter(value?.tipoUfficioId ?? "");
                    }}
                    value={tipiUfficiRicercaOptions.find(option => option.tipoUfficioId == tipoUfficioFilter) ?? null}
                    renderInput={(params) => <TextField fullWidth {...params} label="Tipo Ufficio" placeholder='Seleziona il tipo' />}
                />
            </Grid>
        </Grid>
}